module.exports = __webpack_public_path__ + "images/accumulated_water.011119a8a694ed5109ee4d3ae438475a.png";